// extracted by mini-css-extract-plugin
export var quillEditor = "_jq-1";
export var variable = "_jq-0";